/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./speechBarAnimation.vue?vue&type=template&id=6cf3f231&scoped=true&"
var script = {}
import style0 from "./speechBarAnimation.vue?vue&type=style&index=0&id=6cf3f231&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf3f231",
  null
  
)

export default component.exports